var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tooltip",staticClass:"sw-Tooltip_TriggerElement"},[_vm._t("trigger-element"),_vm._v(" "),_c('div',{ref:"tooltipContent",staticClass:"sw-Tooltip_Content"},[_vm._t("tooltip-content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }